<div class="wrapper-heatmap-view">

  <!-- Header -->
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center gap-2">
          <a routerLink="/dashboard/replay/heatmap" class="btn btn-back flex-shrink-0" [attr.aria-label]="'Back' | translate">
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title" [attr.data-parent]="'Heatmap' | translate">{{ "Heatmap" | translate }}</div>
          <span *ngIf="session?.session_id" class="session-badge font-monospace ms-1">{{ session.session_id }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3">

    <!-- Loading -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">{{ "Loading heatmap..." | translate }}</p>
    </div>

    <!-- Error -->
    <div *ngIf="!isLoading && error" class="text-center py-5">
      <i class="fi fi-rr-exclamation" style="font-size: 2rem; color: #ccc;"></i>
      <p class="mt-2 text-muted">{{ error }}</p>
    </div>

    <!-- Player Card -->
    <div *ngIf="!isLoading && !error && events.length > 0" class="player-card" [class.is-fullscreen]="isFullscreen">

      <!-- Info bar -->
      <div class="controls-bar hm-info-bar">
        <div class="d-flex align-items-center gap-4 flex-wrap">
          <div class="hm-info-item">
            <span class="hm-info-label">{{ "Page" | translate }}</span>
            <span class="hm-info-value">{{ session?.page || '-' }}</span>
          </div>
          <div class="hm-info-item">
            <span class="hm-info-label">{{ "Platform" | translate }}</span>
            <span class="hm-info-value">{{ session?.platform || '-' }}</span>
          </div>
          <div class="hm-info-item">
            <span class="hm-info-label">{{ "Duration" | translate }}</span>
            <span class="hm-info-value">{{ formatDuration(session?.duration_ms) }}</span>
          </div>
          <div class="hm-info-item">
            <span class="hm-info-label">{{ "Scroll Depth" | translate }}</span>
            <span class="hm-info-value">{{ session?.scroll_depth_pct !== undefined ? session.scroll_depth_pct : '-' }}%</span>
          </div>
          <div class="hm-info-item">
            <span class="hm-info-label">{{ "Clicks" | translate }}</span>
            <span class="hm-info-value">{{ session?.click_count !== undefined ? session.click_count : '-' }}</span>
          </div>
          <div class="hm-info-item">
            <span class="hm-info-label">{{ "Rage Clicks" | translate }}</span>
            <span class="hm-info-value" [class.text-danger]="session?.rage_click_count > 0">
              {{ session?.rage_click_count !== undefined ? session.rage_click_count : '-' }}
            </span>
          </div>
        </div>
      </div>

      <!-- rrweb root + heatmap canvas overlay -->
      <div class="player-area">
        <div *ngIf="!playerReady" class="player-initializing">
          <div class="spinner-border text-secondary" role="status"></div>
          <p class="mt-3 text-muted small">{{ "Preparing heatmap..." | translate }}</p>
        </div>
        <div class="player-scale-clip" [class.invisible]="!playerReady">
          <div id="hm-player-root"></div>
          <canvas id="hm-canvas" class="hm-canvas"></canvas>
        </div>
      </div>

    </div>
  </div>
</div>
